import { BaseControlBehaviour } from './BaseControlBehaviour';
export class NotificationBehaviour extends BaseControlBehaviour {
    constructor() {
        super('notification-toggler');
    }

    getInstalledTag() {
        return this.tagInstalled;
    }

    private static installTogglers(
        togglers: JQuery,
        blockSelector: HTMLElement
    ): void {
        const pages = $('[data-stage]', blockSelector);

        $('.m-page').text('1 / ' + pages.length);

        $(togglers).click(function () {
            const currentPage = $(pages).filter('.m-active');

            const num: number = $(currentPage).data('stage');

            const direction = $(this).data('toggledirection');

            let nextNum = 0;

            switch (direction) {
                case 'prev': {
                    nextNum = num == 0 ? num : num - 1;

                    $('[data-toggleDirection="next"]', blockSelector).show();
                    $('[notification-confirm]', blockSelector).hide();

                    if (nextNum == 0) {
                        $(this).hide();
                    }
                    break;
                }
                case 'next': {
                    nextNum = num === pages.length - 1 ? 0 : num + 1;

                    $('[data-toggleDirection="prev"]', blockSelector).show();

                    if (nextNum == pages.length - 1) {
                        $('[notification-confirm]', blockSelector).show();

                        $(this).hide();
                    }

                    break;
                }
            }

            const nextPage = $(pages).filter(
                '[data-stage="' + nextNum + '"]'
            )[0];

            $('.m-page').text(nextNum + 1 + ' / ' + pages.length);

            $(currentPage).hide();
            $(nextPage).show();

            $(currentPage).removeClass('m-active');
            $(nextPage).addClass('m-active');
        });
    }

    private static installCloseButton(blockSelector: HTMLElement): void {
        $(
            '[notification-close-control], [notification-confirm]',
            blockSelector
        ).click(function () {
            const id = $(this).data('notificationid');

            $('.notification-message-container', blockSelector).css(
                'display',
                'none'
            );

            $('[data-stage]', blockSelector).each(function (i, elem) {
                $(elem).hide();
                $(elem).removeClass('m-active');

                if (i == 0) {
                    $(elem).show();
                    $(elem).addClass('m-active');
                }
            });

            $('.m-page').text('');

            $('[data-stage = "0"]', blockSelector).addClass('m-active');

            const noShow = $(
                '.superexpress-checkbox__input',
                blockSelector
            ).prop('checked');

            const res = Ajax.postJson('/api/notification/close', {
                data: { notificationId: id, showNoMore: noShow },
            });

            res.done(function (data) {
                if (!data.isPersistent) {
                    $(blockSelector).remove();
                }
            });

            UiBlock.unBlock({ selector: '_window' });
        });
    }

    private getNotificationContentNode(
        senderElement: HTMLElement
    ): HTMLElement {
        const key = $(senderElement).attr('notificationkey');
        return $(`[contentNotificationKey = "${key}"]`, document)[0];
    }

    public static ShowModalWindow(notificationKey: string) {
        const contentNode = $(
            `[contentNotificationKey = "${notificationKey}"]`,
            document
        )[0];

        if (contentNode) {
            const togglers = $('[notification-page-toggle]', contentNode);
            NotificationBehaviour.installTogglers(togglers, contentNode);
            NotificationBehaviour.installCloseButton(contentNode);

            $('.notification-message-container', contentNode).css(
                'display',
                'flex'
            );
            Ajax.postJson('/api/notification/setviewed', {
                data: { notificationKey: notificationKey },
            });

            UiBlock.block({
                message: contentNode,
                selector: '_window',
            });
        }
    }

    public ShowModalWindow(
        senderElement: HTMLElement,
        internalHandler: Function
    ) {
        const contentNode = this.getNotificationContentNode(senderElement);

        if (contentNode) {
            const togglers = $('[notification-page-toggle]', contentNode);

            NotificationBehaviour.installTogglers(togglers, contentNode);
            NotificationBehaviour.installCloseButton(contentNode);

            $('.notification-message-container', contentNode).css(
                'display',
                'flex'
            );

            const key = $(senderElement).attr('notificationkey');

            Ajax.postJson('/api/notification/setviewed', {
                data: { notificationKey: key },
            });

            UiBlock.block({
                message: contentNode,
                selector: '_window',
            });

            if ($(senderElement).attr('isTriggeredOnce') == 'true')
                $('[isTriggeredOnce]', document).each((i, element) =>
                    $(element).removeAttr('notificationkey')
                );
        }

        if (internalHandler) internalHandler();
    }

    private showNotification(content: HTMLElement): void {
        $('.notification-message-container', content).css('display', 'flex');

        UiBlock.block({
            message: content,
            selector: '_window',
        });
    }

    protected installBehaviour(element: HTMLElement): void {
        const contentNode = this.getNotificationContentNode(element);

        if (contentNode) {
            const togglers = $('[notification-page-toggle]', contentNode);

            NotificationBehaviour.installTogglers(togglers, contentNode);
            NotificationBehaviour.installCloseButton(contentNode);

            const isAutoShow = $(element).data('autoshow') == true;

            if (isAutoShow) {
                const key = $(element).attr('notificationkey');

                Ajax.postJson('/api/notification/setviewed', {
                    data: { notificationKey: key },
                });

                this.showNotification(contentNode);
            } else {
                $(element).on('click', function () {
                    const key = $(element).attr('notificationkey');

                    Ajax.postJson('/api/notification/setviewed', {
                        data: { notificationKey: key },
                    });

                    this.showNotification(contentNode);

                    if ($(element).attr('isTriggeredOnce') == 'true')
                        $(element).removeAttr('notificationkey');
                });
            }
        }
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.NotificationBehaviour = NotificationBehaviour;